import React from 'react'
import type { NextPage } from 'next'
import Image from 'next/image'

import MetaTags from 'components/MetaTags'
import Container from 'components/Container'
import {
  PrivacyPolicyContainer,
  PrivacyPolicyTitle,
  PrivacyPolicyItem,
  PrivacyPolicyItemTitle,
  PrivacyPolicyItemText,
} from './styled'

import { defaultMeta } from 'shared/constants'
import privacyPolicy from 'shared/constants/privacy-policy.json'

const PrivacyPolicy: NextPage = () => {
  return (
    <Container>
      <MetaTags data={defaultMeta} />

      <PrivacyPolicyContainer>
        <Image
          src="/assets/career/careerHeroImage.webp"
          alt="The Silverlogic"
          width={228}
          height={228}
        />
        <PrivacyPolicyTitle>Privacy Policy</PrivacyPolicyTitle>
        {privacyPolicy.map((item, index) => (
          <PrivacyPolicyItem key={index}>
            <PrivacyPolicyItemTitle
              component={item.titleTag as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'}
            >
              {item.title}
            </PrivacyPolicyItemTitle>
            {item.text.map((paragraph, index, array) => (
              <React.Fragment key={index}>
                <PrivacyPolicyItemText>{paragraph}</PrivacyPolicyItemText>
                {index !== array.length - 1 && <br />}
              </React.Fragment>
            ))}
          </PrivacyPolicyItem>
        ))}
      </PrivacyPolicyContainer>
    </Container>
  )
}

export default PrivacyPolicy
